import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SaveSlackIntegrationInput3jeifrdutkqgi as SaveSlackIntegrationInput } from '../SaveSlackIntegrationInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationInput_InputAdapterClass;
function SaveSlackIntegrationInput_InputAdapter() {
  if (SaveSlackIntegrationInput_InputAdapterClass === VOID) {
    class $ {
      s41(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      l75(writer, customScalarAdapters, value) {
        writer.k4e('partyId');
        get_partyIdAdapter().t41(writer, customScalarAdapters, value.i74_1);
        writer.k4e('team');
        get_StringAdapter().t41(writer, customScalarAdapters, value.j74_1);
        writer.k4e('channel');
        get_StringAdapter().t41(writer, customScalarAdapters, value.k74_1);
      }
      t41(writer, customScalarAdapters, value) {
        return this.l75(writer, customScalarAdapters, value instanceof SaveSlackIntegrationInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SaveSlackIntegrationInput_InputAdapter', VOID, VOID, [Adapter()]);
    SaveSlackIntegrationInput_InputAdapterClass = $;
  }
  return SaveSlackIntegrationInput_InputAdapterClass;
}
var SaveSlackIntegrationInput_InputAdapter_instance;
function SaveSlackIntegrationInput_InputAdapter_getInstance() {
  return SaveSlackIntegrationInput_InputAdapter_instance;
}
//region block: init
SaveSlackIntegrationInput_InputAdapter_instance = new (SaveSlackIntegrationInput_InputAdapter())();
//endregion
//region block: exports
export {
  SaveSlackIntegrationInput_InputAdapter_instance as SaveSlackIntegrationInput_InputAdapter_instanceudbjfe9yrgfb,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationInput_InputAdapter.mjs.map
